import { render, staticRenderFns } from "./RoleMixin.vue?vue&type=template&id=3188852a&"
import script from "./RoleMixin.vue?vue&type=script&lang=js&"
export * from "./RoleMixin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports